import React from "react";
import { AlertTriangle } from "lucide-react";

export default function LowStockPopup({ items, onClose }) {
  const list = Array.isArray(items) ? items.filter(Boolean) : [];
  if (!list.length) return null;
  return (
    <div className="fixed inset-0 z-[80] bg-black/50 flex items-center justify-center p-4" onClick={onClose} data-testid="low-stock-popup">
      <div className="bg-white rounded-md w-full max-w-md p-6 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start gap-3 mb-4">
          <div className="h-10 w-10 rounded-full bg-amber-100 text-amber-700 flex items-center justify-center shrink-0">
            <AlertTriangle className="w-5 h-5" />
          </div>
          <div>
            <h3 className="font-heading text-xl font-semibold">Scorta minima raggiunta</h3>
            <p className="text-sm text-velta-mute mt-1">Ricarica in magazzino prima che l&apos;articolo finisca.</p>
          </div>
        </div>
        <ul className="space-y-2 mb-5 max-h-48 overflow-auto">
          {list.map((a) => (
            <li key={a.product_id || a.product_name} className="flex items-center justify-between gap-3 border border-amber-200 bg-amber-50 rounded-md px-3 py-2 text-sm">
              <span className="font-medium">{a.product_name}</span>
              <span className="font-mono text-amber-800">{a.qty} / min {a.limit}</span>
            </li>
          ))}
        </ul>
        <button type="button" data-testid="low-stock-ok" onClick={onClose} className="w-full h-12 bg-[#1E2D5B] text-white rounded-md font-medium btn-tactile">
          Ho capito
        </button>
      </div>
    </div>
  );
}
